import request from '@/utils/request'
// 对应后端product 服务
 
export function getSalesRelation(params) {
    return request({
        url: `/product/sales/external/seller/relation/page`,
        method: 'GET',
        params:params
    })
} 
// /sales/external/seller/goods/page
// 卖家分页查询商品列表
export function getGoodsPage(params) {
    return request({
        url: `/product/sales/external/seller/goods/page`,
        method: 'GET',
        params:params
    })
} 

// /goodsbase/goods/unit/feeRate/{shopId}/{goodsId}
// 商品平台服务费比例及单位信息
export function getUnitFeeRate(data) {
    return request({
        url: `/product/goodsbase/goods/unit/feeRate/${data.shopId}/${data.goodsId}`,
        method: 'GET' 
    })
} 

// 卖家分页查询基库商品列表
export function queryGoodsBasePage(params) {
    return request({
        url: `/product/goodsbase/notcheck/page`,
        method: 'GET',
        params:params
    })
} 

// 根据goods_id查询商品下的所以批号
// /compliance/sku/getBatchNumbers

export function getBatchNumbers(params) {
    return request({
        url: `/product/compliance/sku/getBatchNumbers`,
        method: 'GET',
        params:params
    })
} 

// 新增召回信息
export function messageRecallAdd(data) {
    return request({
        url: `/message/recall/add`,
        method: 'POST',
        data:data
    })
} 


// 后台召回列表
export function messageRecallQuery(params) {
    return request({
        url: `/message/recall/page`,
        method: 'GET',
        params:params
    })
} 

// 后台召回 单条查看
export function messageRecallQueryDetail(params) {
    return request({
        url: `/message/recall/get`,
        method: 'GET',
        params:params
    })
} 


// /recall/delete
// 删除召回
export function messageRecallDelete(data) {
    return request({
        url: `/message/recall/delete`,
        method: 'POST',
        data:data
    })
}
// 控销 平台查询控销商品列表
// /sales/external/sys/relation/page
export function getRelationPage(data) {
    return request({
        url: `/product/sales/external/sys/relation/page`,
        method: 'GET',
        params:data
    })
} 
 
//检查项- 商品检查 查询列表
export function getSkuListForCheck(data) {
    return request({
        url: `/product/compliance/sku/getSkuListForCheck`,
        method: 'GET' ,
        params:data
    })
} 

// /ledgerRules/getStandbySaleRuleOpenTips
//获取备用分账开启提醒信息
export function getStandbySaleRuleOpenTips(data) {
    return request({
        url: `/product/ledgerRules/getStandbySaleRuleOpenTips`,
        method: 'POST' ,
        data:data
    })
} 

// /ledgerRules/setStandbyEnable
//设置备用分账是否关闭
export function setStandbyEnable(data) {
    return request({
        url: `/product/ledgerRules/setStandbyEnable`,
        method: 'POST' ,
        data:data
    })
} 

// 保存备用分账 setStandbyRule
export function setStandbyRule(data) {
    return request({
        url: `/product/ledgerRules/setStandbyRule`,
        method: 'POST' ,
        data:data
    })
} 



// 卖家分页查询 召回商品
export function queryGoodsBaseCallBackNew(params) {
    return request({
        url: `/product/goodsbase/admin/notcheck/page`,
        method: 'GET',
        params:params
    })
} 
// queryAgencyControlPinSku/{goodsSkuId} 查询
export function queryAgencyControlPinSku(goodsSkuId) {
    return request({
        url: `/product/sales/sku/queryAgencyControlPinSku/${goodsSkuId}`,    
        method: 'GET', 
    })
}    